import React, { useEffect, useRef, useState} from 'react'
import styles from './DispatchPage.module.css'
import {
    AppBar,
    Button, Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText, FormControlLabel,
    IconButton,
} from '@material-ui/core'
import SignatureCanvas from 'react-signature-canvas'
import TextField from '@mui/material/TextField'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import { v4 as uuid } from "uuid";
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import Compressor from 'compressorjs';


import {
    Alert,
    CardHeader,
    FormControl,
    Grid,
    ImageList,
    InputLabel, ListItem, ListItemAvatar, ListItemIcon,
    MenuItem,
    Select
} from '@mui/material'
import { useParams } from 'react-router'
import {
    DispatchDataObject,
    useUpdateDispatch,
} from '../../queries/useDispatch'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import cn from 'classnames'
import { Wrapper } from '@googlemaps/react-wrapper'

import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto'
import ClearIcon from '@mui/icons-material/Clear';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Add } from '@mui/icons-material'
import { EquipmentForm } from './EquipmentForm'
import { TimeEntryForm } from './TimeEntryForm'
import Dropzone from "react-dropzone";
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import axios from "axios";
import PdfViewerComponent from "../../components/PdfViewerComponent";
import dayjs from "dayjs";
import LoadingBackdrop from "../../components/common/LoadingBackdrop";
import Snackbar from "@mui/material/Snackbar";
import {setNetworkState, useNetworkOnline} from "../../slices/authSlice";
import {getConfig} from "../../AppConfig";
import { db } from './db';

interface Params {
    userGuid: string
}

const MapComponent: React.FC<{
    center: { lat: number; lng: number }
    zoom: number
}> = ({ center, zoom }) => {
    const mapRef = useRef<HTMLDivElement>()
    const mapInstanceRef = useRef<any>(null)

    useEffect(() => {
        if (mapInstanceRef.current) return // already initialized, don't recreate

        // @ts-ignore
        mapInstanceRef.current = new window.google.maps.Map(mapRef.current, {
            center,
            zoom
        })

        // @ts-ignore
        const marker = new window.google.maps.Marker({
            position: center,
            map: mapInstanceRef.current
        })

        marker.addListener("click", () => {
            window.open("https://maps.google.com?q=" + center.lat + "," + center.lng)
        })
    }, []) // empty deps - only run once on mount

    return (
        <div
            ref={mapRef}
            style={{ backgroundColor: 'lightblue', width: '100%', height: '300px' }}
        />
    )
}

const DispatchPage = () => {
    const { version } = getConfig()
    const { apiUrl, mapapikey, secretkey } = getConfig()
    const [disableSubmit, setDisableSubmit] = useState(false)
    const [equipmentData, setEquipmentData] = React.useState([])
    const [equipmentFormData, setEquipmentFormData] = React.useState([])
    const [offlinePhotoIds, setOfflinePhotoIds] = React.useState([])
    const { userGuid } = useParams<Params>()
    const [isFormShowing, setIsFormShowing] = useState(false)
    const [isTEFormShowing, setIsTEFormShowing] = useState(false)
    const [reloadTEForm, setReloadTEForm] = useState<number>(0)
    const [gridParams, setGridParams] = useState({})
    const [reloadForm, setReloadForm] = useState<number>(0)
    const [dialogObj, setDialogObj] = React.useState({ msg: '', id: 0 })
    const [dialogTimeEntryObj, setDialogTimeEntryObj] = React.useState({ msg: '', starttravel: new Date(), employeeid: 0 })
    const [dispatchDataHold, setDispatchDataHold] = React.useState<DispatchDataObject>(null)
    const [dialogObjPhoto, setDialogObjPhoto] = React.useState({ msg: '', name: '', id: 0 })
    const [dialogMsg, setDialogMsg] = React.useState("")
    const [photos, setPhotos] = React.useState([])
    const [documents, setDocuments] = React.useState([])
    const [dispatchData, setDispatchData] = React.useState<DispatchDataObject>(null);
    const [viewDataBody, setViewDataBody] = React.useState({id: ''})
    const [watchLogoDataURL, setWatchLogoDataURL] = React.useState(null)
    const [documentData, setDocumentData] = React.useState({filedata: '', fileext: '', filename: '', fileurl: '', id: '', serverModified: null})
    const [openViewer, setOpenViewer] = React.useState(false)
    const [documentsLoading, setDocumentsLoading] = React.useState([])
    const [commentText, setCommentText] = React.useState('')
    const [titleMessage, setTitleMessage] = React.useState('Loading Schedule')
    const [timeEntries, setTimeEntries] = React.useState([])
    const [teEdit, setTEEdit] = React.useState(false)
    const [loadingBackdrop, setLoadingBackdrop] = React.useState(false)
    const signCanvasCustomerRep = React.useRef() as React.MutableRefObject<any>;
    const signCanvasFieldRep = React.useRef() as React.MutableRefObject<any>;
    const signCanvasCompanyRep = React.useRef() as React.MutableRefObject<any>;
    const [jobTypeActiveSelect, setJobTypeActiveSelect] = React.useState<string>("")
    const [jobTypeActiveSelectId, setJobTypeActiveSelectId] = React.useState<number>()
    const [customerRepActiveSelect, setCustomerRepActiveSelect] = React.useState<string>("")
    const [emergencyCustomerNumberActiveSelect, setEmergencyCustomerNumberActiveSelect] = React.useState<string>("")
    const [emergencyAddressActiveSelect, setEmergencyAddressActiveSelect] = React.useState<string>("")
    const [employeeSelect, setEmployeeSelect] = React.useState<string>("")
    const [employeeSelectId, setEmployeeSelectId] = React.useState<number>()

    const [emergencyCustomerActiveSelect, setEmergencyCustomerActiveSelect] = React.useState<string>("")
    const [emergencyCustomerActiveSelectId, setEmergencyCustomerActiveSelectId] = React.useState<number>()
    const [fieldRepActiveSelect, setFieldRepActiveSelect] = React.useState<string>("")
    const [signCanvasCustomerBase64, setSignCanvasCustomerBase64] = useState("")
    const [signCanvasFieldBase64, setSignCanvasFieldBase64] = useState("")
    const [signCanvasCompanyBase64, setSignCanvasCompanyBase64] = useState("")
    const [customerSignOff2, setCustomerSignOff2] = useState(false)
    const [fieldRepNotOnSite, setFieldRepNotOnSite] = React.useState<boolean>(false)
    const [tempSaveId, setTempSaveId] = useState(0)

    // Time Entry
    const [reloadData, setReloadData] = React.useState<number>(1)
    // const [reloadDatabaseData, setReloadDatabaseData] = React.useState<number>(1)
    const [syncServer, setSyncServer] = React.useState<number>(1)


    const [customerSigned, setCustomerSigned] = React.useState()
    const [fieldSigned, setFieldSigned] = React.useState()
    const [companySigned, setCompanySigned] = React.useState()

    const [snackbarOpen, setSnackbarOpen] = React.useState({ open: false, message: '' })
    const networkOnline = useNetworkOnline()

    const getDBRecord = async (id: string) => {
        try {
            const data = await db.dispatch.get(id);
            // alert ("Json: " + data);
            return data;
        }
        catch (e) {
            console.log(e)
        }
    }

    const addDBRecord = async (id: string, jsonString: string) => {
        try {
            return db.dispatch.put({ json: jsonString, uuid: id }, id)
        }
        catch (e) {
            console.log(e)
        }
    }

    const addDocumentDBRecord = async (id: string, blobData: Blob) => {
        try {
            debugger
            return db.documents.put({ blobData: blobData, uuid: id }, id)
        }
        catch (e) {
            console.log(e)
        }
    }

    const getDocumentDBRecord = async (id: string) => {
        try {
            debugger
            return await db.documents.get(id)
        }
        catch (e) {
            console.log(e)
        }
    }

    const loadDatabaseRecord = async (userGuidToPro) => {
        const record = await getDBRecord(userGuidToPro)
        if (record) {
            return JSON.parse(record.json)
        }
        else {
            return undefined
        }
    }

    const loadPhotosDatabaseRecord = async (userGuidToPro) => {
        const record = await getDBRecord(userGuidToPro + '-photos')
        if (record) {
            return JSON.parse(record.json)
        }
        else {
            return undefined
        }
    }

    const loadDocumentsDatabaseRecord = async (userGuidToPro) => {
        const record = await getDBRecord(userGuidToPro + '-documents')
        if (record) {
            return JSON.parse(record.json)
        }
        else {
            return undefined
        }
    }


    const getPhotoSectionData = () => {
        return {
            "sectionname": "*PHOTOS*",
            "data": photos.map((photo) => { return { photo: photo.imageData, id: photo.id, filename: photo.name, filesize: photo.size, filetype: photo.type }}),
        }
    }

    function dataURLtoFile(dataurl: string, filename: string) {
        var arr = dataurl.split(","),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[arr.length - 1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, { type: mime });
    }


    const getSectionsData = (sectiondata, includePhotos: Boolean) => {
        // getDatabaseTempSaveId()
        if (sectiondata && sectiondata?.sections && sectiondata?.sections?.length > 0) {
            return sectiondata.sections.map((section) => {
                if (section.sectionname === "*TIMEENTRY*") {
                    // console.log(timeEntries)
                    return {
                        "sectionname": "*TIMEENTRY*",
                        "data": timeEntries,
                        "employeelist": section.employeelist,
                        "vehiclelist": section.vehiclelist,
                        "sectiondata": section.sectiondata
                    }
                } else if (section.sectionname === "*EQUIPMENT*") {
                    // console.log(equipmentData)
                    return {
                        "sectionname": "*EQUIPMENT*",
                        "data": equipmentData,
                        "equipmentlist": section.equipmentlist,
                        "sectiondata": section.sectiondata
                    }
                }
                else if (includePhotos && section.sectionname === "*PHOTOS*") {
                    return {
                        "sectionname": "*PHOTOS*",
                        "data": photos.map((photo) => { return { photo: photo.imageData, id: photo.id, filename: photo.name, filesize: photo.size, filetype: photo.type }}),
                        "sectiondata": section.sectiondata
                    }
                }
                else if (section.sectionname === "*DOCUMENTS*") {
                    return {
                        "sectionname": "*DOCUMENTS*",
                        "filelist": documents,
                        "sectiondata": section.sectiondata
                    }
                    // return section
                }
                else if (section.sectionname === "*EMERGENCY*") {
                    console.log('emergency - datasave')
                    console.log(emergencyAddressActiveSelect)
                    return {
                        "sectionname": "*EMERGENCY*",
                        "data": [{
                            "customerid": emergencyCustomerActiveSelectId,
                            "customer": emergencyCustomerActiveSelect,
                            "customernumber": emergencyCustomerNumberActiveSelect,
                            "address": emergencyAddressActiveSelect
                        }],
                        "sectiondata": section.sectiondata,
                        "customerlist": section.customerlist,
                    }
                }
                else if (section.sectionname === "*CUSTOMERSIGNOFF*") {
                    setCustomerSignOff2(false)

                    return {
                        "sectionname": "*CUSTOMERSIGNOFF*",
                        "data": [{
                            "companyrep": employeeSelect,
                            "companyrepid": employeeSelectId,
                            "customerrep": customerRepActiveSelect,
                            // "customerrepid": customerRepActiveSelectId,
                            "jobtype": jobTypeActiveSelect,
                            "jobtypeid": jobTypeActiveSelectId,
                            "comment": commentText,
                            "customerSignedImage": signCanvasCustomerBase64,
                            "companySignedImage": signCanvasCompanyBase64,
                        }],
                        "companyreplist": section.companyreplist,
                        "jobtypelist": section.jobtypelist,
                        "sectiondata": section.sectiondata
                    }
                }
                else if (section.sectionname === "*CUSTOMERSIGNOFF2*") {
                    setCustomerSignOff2(true)
                    return {
                        "sectionname": "*CUSTOMERSIGNOFF2*",
                        "data": [{
                            "customerrep": customerRepActiveSelect,
                            "fieldrep": fieldRepActiveSelect,
                            "comment": commentText,
                            "fieldrepnotonsite": fieldRepNotOnSite,
                            "customerSignedImage": signCanvasCustomerBase64,
                            "fieldrepSignedImage": signCanvasFieldBase64,
                        }],
                        "companyreplist": section.companyreplist,
                        "jobtypelist": section.jobtypelist,
                        "sectiondata": section.sectiondata
                    }
                }
                else {
                    return section
                }
            })
        }
        else {
            return (
                <></>
            )
        }
    }

    const getSubmitData = (data, includePhotos: Boolean) => {
        let submitData = null;
        if (data) {
            const tempid = tempSaveId > 0 ? tempSaveId : data.tempsaveid
            submitData = {
                "dispatchsendid": data.dispatchsendid,
                "tempsaveid": tempid,
                "sectiondata": data.sectiondata,
                "isreadonly": data.isreadonly,
                "title": data.title,
                "sections": getSectionsData(data, includePhotos)
            }
        }

        return submitData
    }

    const sendSave = () => {
        const submitData = getSubmitData(dispatchData, true)
        return (submitData ? updateDistpatch.mutateAsync(submitData) : null)
    }

    const getDispatchData = async () => {
        const { data } = await axios.get('/dispatch/' + userGuid, {})
        if (data && data?.jsonString) {
            const parsedData = JSON.parse(data.jsonString)

            if (parsedData && parsedData?.sections?.length) {
                var selection = parsedData?.sections?.find((item) => item.sectionname === '*DOCUMENTS*')

                if (selection?.filelist && selection?.filelist?.length > 0) {
                    const tempFileList = selection?.filelist?.map(fileItem => {
                        return {id: fileItem.Id, name: fileItem.Name, CreatedTime: fileItem.CreatedTime, ParentId: fileItem.ParentId, IsFolder: fileItem.IsFolder, SubItems: fileItem.SubItems}
                    })
                    console.log(tempFileList)
                    selection.filelist = tempFileList
                }
            }

            setDispatchDataHold(parsedData as DispatchDataObject)
        }

    }

    useEffect(() => {
        debugger
        getDispatchData()
    }, [])

    useEffect(() => {
        if (networkOnline) {
            debugger
            setSyncServer(syncServer+1)
        }
    }, [networkOnline])


    useEffect(() => {
        debugger
        if (syncServer > 2) {
            console.log('sync server')
            // Delete photo's when we come back online
            if (offlinePhotoIds?.length > 0) {
                offlinePhotoIds?.map(id => {
                    deleteTempPhoto(id)
                })
                setOfflinePhotoIds([])
            }

            // saveDBRec(userGuid, true)
            writeDatabaseRecord(dispatchData, true)
            // const photoGuid = userGuid + '-photos'
            // saveDBPhotosRec(photoGuid)
            writeDatabaseRecordForPhotos(true)
        }
    }, [syncServer])

    const updateDistpatch = useUpdateDispatch()
    // const updateTempDispatch = useUpdateTempDispatch()

    const saveDBRec = async (userGuidToPro) => {
        const record = await getDBRecord(userGuidToPro)

        if (record) {
            // console.log(JSON.parse(record.json))
            axios.put(`dispatchsave`, JSON.parse(record.json)).then((response) => {
                const dataJson = JSON.parse(response.data.jsonString)
                setTempSaveId(dataJson.tempsaveid)
            })
        }
    }

    const saveDBPhotosRec = async (userGuidToPro) => {

        const record = await getDBRecord(userGuidToPro)
        if (record) {
            const tempsavephotos = JSON.parse(record.json)
            const newPhotos = tempsavephotos?.data?.map(imgData => {
                return {
                    "id": imgData.id,
                    "imageData": imgData.photo,
                    "name": imgData.filename,
                    "size": imgData.filesize,
                    "type": imgData.filetype,
                }
            })
            uploadTempPhoto(newPhotos)
        }

        // Delete photo's when we come back online
        console.log('checking offline photo')
        if (offlinePhotoIds?.length > 0) {
            offlinePhotoIds?.map(id => {
                console.log('deleting')
                deleteTempPhoto(id)
            })
            setOfflinePhotoIds([])
        }
    }

    const writeDatabaseRecordForPhotos = (serverSave) => {
        const photoGuid = userGuid + '-photos'
        const photoSectionData = JSON.stringify(getPhotoSectionData())
        // console.log(photoSectionData)
        addDBRecord(photoGuid, photoSectionData).then(
            id => {
                // console.log('ID Generated: ', id);
                if (serverSave && networkOnline) {
                    saveDBPhotosRec(photoGuid)
                }
            },
            error => {
                if (serverSave && networkOnline) {
                    saveDBPhotosRec(photoGuid)
                }
                console.log(error);
            }
        )
    }

    const writeDatabaseRecord = (dataToSave, saveServer) => {
        if (dataToSave) {
            const newData = JSON.stringify(getSubmitData(dataToSave, false))
            addDBRecord(userGuid, newData).then(
                id => {
                    console.log('ID Generated: ', id);
                    // setDispatchData(newData)
                    if (saveServer) {
                        saveDBRec(userGuid)
                    }
                },
                error => {
                    if (saveServer && networkOnline) {
                        saveDBRec(userGuid)
                    }
                    console.log(error);
                }
            )
        }
    }

    useEffect(() => {
        debugger
        if (dispatchData) {
            writeDatabaseRecord(dispatchData, false)
        }
    }, [tempSaveId])

    useEffect(() => {
        debugger
        const internalReload = async () => {
            debugger
            var databaseDBTempId = tempSaveId

            if (dispatchDataHold?.isreadonly) {
                console.log('isReadOnly')
                db.dispatch.get(userGuid).then(
                    (record) => {
                        db.dispatch.delete(userGuid)
                    })
                db.dispatch.get(userGuid + '-photos').then(
                    (record) => {
                        db.dispatch.delete(userGuid + '-photos')
                    })
                db.dispatch.get(userGuid + '-documents').then(
                    (record) => {
                        db.dispatch.delete(userGuid + '-documents')
                    })

                setDispatchData(dispatchDataHold)
            }
            else {
                db.dispatch.get(userGuid).then(
                    (record) => {
                        // console.log(dispatchDataHold)
                        // console.log(databaseDBTempId)
                        // console.log(record)
                        // console.log(dispatchDataHold?.tempsaveid)

                        if (((!record && dispatchDataHold?.sectiondata?.length > 0) || (dispatchDataHold?.tempsaveid > databaseDBTempId && dispatchDataHold?.sectiondata?.length > 0))) {
                            // if (dispatchDataHold?.tempsaveid > tempSaveId ) {
                            console.log('USING NEW RECORD!!')
                            // setTempSaveId(dispatchDataHold?.tempsaveid)
                            // console.log(dispatchDataHold?.dispatchsendid)
                            getTempPhotos(dispatchDataHold?.dispatchsendid, true)
                            setDispatchData(dispatchDataHold)
                        }
                        else if (record) {
                            console.log('USING DATABASE RECORD!!')
                            console.log(dispatchDataHold)
                            loadDatabaseRecord(userGuid).then((data) => {
                                if (dispatchDataHold) {
                                    var dataSections = data?.sections?.find((section) => {
                                        return section?.sectionname === '*DOCUMENTS*'
                                    })
                                    const dataSectionsHold = dispatchDataHold?.sections?.find((section) => {
                                        return section?.sectionname === '*DOCUMENTS*'
                                    })
                                    console.log(dataSections.filelist)
                                    if (dataSections?.filelist?.length !== dataSectionsHold?.filelist?.length) {
                                        dataSections.filelist = dataSectionsHold?.filelist
                                    }
                                }
                                console.log(data)
                                if (data) {
                                    setDispatchData(data)
                                }
                            })

                            loadPhotosDatabaseRecord(userGuid).then((photosData) => {
                                // console.log(photosData)
                                if (photosData && photosData.data) {
                                    const newData = photosData.data?.map((p: any, i) => {
                                        return { imageData: p.photo, id: p.id, name: p.filename, size: p.filesize, type: p.filetype }
                                    })
                                    setPhotos(newData)
                                }
                            })

                            loadDocumentsDatabaseRecord(userGuid).then((documentsData) => {
                                // console.log(photosData)
                            // \"sectionname\":\"*DOCUMENTS*\",\"data\":[{\"Id\":\"19Ran4_18WzBmKvOC5UFwG30kgNmsUxUM\",\"filename\":\"Golf Test Event2.png\",\"fileext\":\".png\",\"id\":\"19Ran4_18WzBmKvOC5UFwG30kgNmsUxUM\",\"name\":\"Golf Test Event2.png\"},{\"Id\":\"1em8w7_2OiG88gSCc6Y8iGmYASnCvJ-K9\",\"filename\":\"golfballs.jpeg\",\"fileext\":\".jpeg\",\"id\":\"1em8w7_2OiG88gSCc6Y8iGmYASnCvJ-K9\",\"name\":\"golfballs.jpeg\"},{\"Id\":\"1GP3v8IhcbJaqQfNLJGl4QwXVPHu-x63v\",\"filename\":\"test.pdf\",\"fileext\":\".pdf\",\"id\":\"1GP3v8IhcbJaqQfNLJGl4QwXVPHu-x63v\",\"name\":\"test.pdf\"}]}"
                            //     uuid
                            //         :
                            //         "D08F9897-AD6B-434E-BEF2-DFD9D5BB0A0F-documents"

                                // if (documentsData && documentsData.data) {
                                //     setDocuments(documentsData.data)
                                // }
                            })
                            //
                            // db.dispatch.get(userGuid + '-documents').then(
                            //     (record) => {
                            //         if (record) {
                            //             // setDocuments(JSON.parse(record.json))
                            //         }
                            //     })
                        }
                        else {
                            console.log('No data')
                            setDispatchData(dispatchDataHold)
                        }
                    },
                    (error) => {
                        console.log(error)
                        setDispatchData(dispatchDataHold)
                    },
                );
            }
        }
        internalReload()

    }, [dispatchDataHold])

    useEffect(() => {
        debugger
        getAppBarMessage()
        dispatchData?.sections?.map((dispatch, i) => {
            if (dispatch && dispatch.equipmentlist) {
                if (dispatch.equipmentlist.length > 0) {
                    setEquipmentFormData(dispatch.equipmentlist)
                }
                else {
                    setEquipmentFormData([])
                }
            }

            if (dispatch && dispatch.sectionname === '*EQUIPMENT*') {
                if (dispatch.data?.length > 0) {
                    setEquipmentData(dispatch.data)
                }
                else {
                    setEquipmentData([])
                }
            }
            else if (dispatch && dispatch.sectionname === '*EMERGENCY*') {
                if (dispatch.data?.length > 0) {
                    setEmergencyCustomerActiveSelectId(dispatch.data[0].customerid)
                    setEmergencyCustomerActiveSelect(dispatch.data[0].customer)
                    setEmergencyCustomerNumberActiveSelect(dispatch.data[0].customernumber)
                    setEmergencyAddressActiveSelect(dispatch.data[0].address)
                }
                else {
                    setEmergencyCustomerActiveSelectId(null)
                    setEmergencyCustomerActiveSelect('')
                    setEmergencyCustomerNumberActiveSelect('')
                    setEmergencyAddressActiveSelect('')
                }
            }
            else if (dispatch && dispatch.sectionname === '*TIMEENTRY*') {
                if (dispatch.data?.length > 0) {
                    setTimeEntries(dispatch.data)
                }
                else {
                    setTimeEntries([])
                }
            }
            else if (dispatch && dispatch.sectionname === '*PHOTOS*') {
                if (dispatchData.isreadonly) {
                    const newData = dispatch.data?.map((p: any, i) => {
                        // console.log('Image Id: ' + p.id)
                        // console.log('Image Length: ' + p.photo.length)
                        return { imageData: p.photo, id: p.id, name: p.filename, size: p.filesize, type: p.filetype }
                    })
                    // console.log(newData)
                    setPhotos(newData)
                }
            }
            else if (dispatch && dispatch.sectionname === '*DOCUMENTS*') {
                if (dispatch && dispatch?.filelist) {
                    if (networkOnline) {
                        const getDocs = async () => {
                            setDocumentsLoading(dispatch?.filelist.map(f => ({ ...f, progress: 0 })))
                            setDocuments([])
                            const results = []

                            // Download all files concurrently
                            await Promise.all(dispatch.filelist.map(async (file) => {
                                const body2 = {
                                    id: file.id,
                                    filename: file.name,
                                    dispatchsendid: dispatchData.dispatchsendid
                                }

                                const response2 = await fetch(apiUrl + '/dispatchfiledownloadstream', {
                                    method: 'POST',
                                    headers: {
                                        'Content-Type': 'application/json',
                                        'Accept-Encoding': 'gzip, deflate, br',
                                        'Connection': 'keep-alive',
                                    },
                                    body: JSON.stringify(body2),
                                });

                                if (!response2.ok) {
                                    const errorText = await response2.text();
                                    try {
                                        const errorJson = JSON.parse(errorText);
                                        throw new Error(errorJson.message || `HTTP error! status: ${response2.status}`);
                                    } catch {
                                        throw new Error(`HTTP error! status: ${response2.status}`);
                                    }
                                }

                                const reader = response2.body.getReader();
                                const chunks = [];
                                let receivedLength = 0;

                                while(true) {
                                    const {done, value} = await reader.read();

                                    if (done) break;

                                    chunks.push(value);
                                    receivedLength += value.length;

                                    setDocumentsLoading(prev =>
                                        prev.map(f =>
                                            f.id === file.id
                                                ? { ...f, progress: receivedLength }
                                                : f
                                        )
                                    );
                                }

                                const blob = new Blob(chunks);
                                const serverModified = response2.headers.get('X-Server-Modified');

                                if (blob.size > 0) {
                                    await addDocumentDBRecord(file.id, blob).then(
                                        id => {
                                            // console.log('ID Generated: ', id);
                                        },
                                        error => {
                                            console.log(error);
                                        }
                                    )

                                    const fileext = file.name.split('.').pop() || '';
                                    const newDocument = {
                                        Id: file.id,
                                        filename: file.name,
                                        serverModified: serverModified,
                                        fileext: fileext,
                                        ...file
                                    }

                                    results.push(newDocument)

                                    setDocuments(prevDocs => [...prevDocs, newDocument])
                                    setDocumentsLoading(prev => [...prev.filter(f => f.id !== file.id)])
                                }
                            }));

                            setDocumentsLoading(prev => [])

                            if (results && results?.length > 0) {
                                const documentGuid = userGuid + '-documents'
                                const documentSectionData = JSON.stringify(
                                    {
                                        "sectionname": "*DOCUMENTS*",
                                        "data": results
                                    }
                                )

                                await addDBRecord(documentGuid, documentSectionData).then(
                                    id => {
                                        // console.log('ID Generated: ', id);
                                    },
                                    error => {
                                        console.log(error);
                                    }
                                )
                            }
                        }
                        getDocs()
                    }
                }
            }
            else if (dispatch && dispatch.sectionname === '*CUSTOMERSIGNOFF*' && dispatch.data?.length > 0) {
                // console.log( dispatch.sectionname)
                console.log(dispatch)
                const newData = dispatch.data?.map((d: any, i) => {
                    return d
                })

                // console.log(newData)
                const signOffData = newData[0]
                console.log(signOffData)
                setCommentText(signOffData?.comment)
                setJobTypeActiveSelect(signOffData?.jobtype)


                const companyRep = signOffData?.companyrep?.split("-")?.pop()?.trim()
                setEmployeeSelect(companyRep)
                setEmployeeSelectId(signOffData?.companyrepid)

                setCustomerRepActiveSelect(signOffData?.customerrep)
                setFieldSigned(signOffData?.fieldrepSignedImage)
                setCustomerSigned(signOffData?.customerSignedImage)
                setCompanySigned(signOffData?.companySignedImage)

                setSignCanvasCustomerBase64(signOffData?.customerSignedImage)
                setSignCanvasCompanyBase64(signOffData?.companySignedImage)

                var jobToSearchFor = signOffData?.jobtype
                if (jobToSearchFor.length <= 0) {
                    jobToSearchFor = 'Scheduled'
                }
                const selection = dispatch?.jobtypelist?.find((item) => item.jobtype === jobToSearchFor)
                if (selection) {
                    setJobTypeActiveSelect(selection.jobtype)
                    setJobTypeActiveSelectId(selection.jobtypeid)
                }
            }
            else if (dispatch && dispatch.sectionname === '*CUSTOMERSIGNOFF2*' && dispatch.data?.length > 0) {
                console.log( dispatch.sectionname)
                const newData = dispatch.data?.map((d: any, i) => {
                    return d
                })

                const signOffData = newData[0]
                setFieldRepNotOnSite(signOffData?.fieldrepnotonsite)
                setFieldRepActiveSelect(signOffData?.fieldrep)
                setCommentText(signOffData?.comment)
                setJobTypeActiveSelect(signOffData?.jobtype)
                setEmployeeSelect(signOffData?.companyrep)
                setCustomerRepActiveSelect(signOffData?.customerrep)
                setFieldSigned(signOffData?.fieldrepSignedImage)
                setCustomerSigned(signOffData?.customerSignedImage)
                setCompanySigned(signOffData?.companySignedImage)

                var jobToSearchFor = signOffData?.jobtype
                if (jobToSearchFor.length <= 0) {
                    jobToSearchFor = 'Scheduled'
                }
                const selection = dispatch?.jobtypelist?.find((item) => item.jobtype === jobToSearchFor)
                if (selection) {
                    setJobTypeActiveSelect(selection.jobtype)
                    setJobTypeActiveSelectId(selection.jobtypeid)
                }
            }
        })

        if (dispatchData && dispatchData.status !== 'failure') {
            setTempSaveId(dispatchData?.tempsaveid)
        }
        // writeDatabaseRecordForPhotos(false)
    }, [dispatchData])

    const getFileDownload = async (file: any) => {
        const body = {
            id: file.id,
            filename: file.filename,
            dispatchsendid: file.dispatchsendid
        }

        const documentObject = await getDocumentObj(body)
        return documentObject
    }

    const getDocumentsData = async (filelist: any) => {
        console.log(filelist)
        const fileDataArray = filelist.map( async (item) => {
            const body = {
                id: item.Id,
                filename: item.path,
                dispatchsendid: dispatchData.dispatchsendid
            }

            const fileData = await getFileDownload(body)

            return {
                "id": body.id,
                "filename": body.filename,
                "serverModified": item.serverModified,
                "filedata": fileData.filedata,
                "fileext": fileData.fileext
            }
        })

        console.log(await Promise.all(fileDataArray))
        return await Promise.all(fileDataArray)
    }

    const getMainLabels = () => {
        if (
            dispatchData &&
            dispatchData.sectiondata &&
            dispatchData.sectiondata.length > 0
        ) {
            return (dispatchData?.sectiondata).map((dispatch, i) => {
                return (
                    <>
                        <Grid item key={dispatch.value} border={0} xs={8}>
                            <Typography variant="body2" gutterBottom>
                                {dispatch.label}
                            </Typography>
                        </Grid>
                        <Grid item border={0} xs={4}>
                            <Typography variant="body2" gutterBottom>
                                {dispatch.value}
                            </Typography>
                        </Grid>
                    </>
                )
            })
        }
    }

    const getSectionsAccordion = () => {
        if (
            dispatchData &&
            dispatchData.sections &&
            dispatchData.sections.length > 0
        ) {
            return (dispatchData?.sections).map((dispatch, i) => {
                if (dispatch.sectionname === '*EQUIPMENT*') {
                    return (
                        <Accordion disableGutters={true}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant="h6">Equipment</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Grid
                                        container
                                        border={0}
                                        direction="row"
                                        alignItems="center"
                                        height={'100%'}
                                        width={'100%'}
                                    >
                                        {!dispatchData.isreadonly &&
                                            <div style={{width:'25px', height:'25px', paddingBottom: '25px'}}>
                                                <IconButton
                                                    className={styles.submitButton}
                                                    onClick={() => handleEquipmentAdd()}
                                                    size="small">
                                                    <Add />
                                                </IconButton>
                                            </div>
                                        }
                                        {getEquiptmentCardDetails()}
                                    </Grid>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    )
                }
                else if (dispatch.sectionname === '*EMERGENCY*') {
                    return (
                        <Accordion disableGutters={true}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant="h6">Emergency/Additional Job</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Grid
                                        container
                                        border={0}
                                        direction="row"
                                        alignItems="center"
                                        height={'100%'}
                                        width={'100%'}
                                    >
                                        {getEmergencyAccordionDetails(dispatch?.customerlist)}
                                    </Grid>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    )
                }
                else if (dispatch.sectionname === '*PHOTOS*') {
                    const accordianPhotoDetails = getPhotoAccordionDetails()
                    return (
                        <Accordion disableGutters={true}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant="h6">Photos</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Grid
                                        container
                                        border={0}
                                        direction="row"
                                        alignItems="center"
                                        height={'100%'}
                                        width={'100%'}
                                    >
                                        {accordianPhotoDetails}
                                    </Grid>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    )
                }
                else if (dispatch.sectionname === '*DOCUMENTS*') {
                    return (
                        <Accordion disableGutters={true}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant="h6">Documents</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Grid
                                        container
                                        border={0}
                                        direction="row"
                                        alignItems="center"
                                        height={'100%'}
                                        width={'100%'}
                                    >
                                        {getDocumentAccordionDetails(dispatch?.filelist)}
                                    </Grid>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    )
                }
                else if (dispatch.sectionname === '*TIMEENTRY*') {
                    return (
                        <>
                            <TimeEntryForm
                                isOpen={isTEFormShowing}
                                setIsOpen={setIsTEFormShowing}
                                reloadForm={reloadTEForm}
                                employeeList={dispatch?.employeelist}
                                vehicleList={dispatch?.vehiclelist}
                                timeEntries={timeEntries}
                                setTimeEntries={setTimeEntries}
                                gridParams={gridParams}
                                isEdit={teEdit}
                                dispatchid={null}
                                timeid={null}
                                shouldSubmit={false}
                                reloadData={syncServer}
                                setReloadData={setSyncServer}
                            />
                            <Accordion disableGutters={true}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography variant="h6">Time Entry</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Box>
                                        <Grid
                                            container
                                            border={0}
                                            direction="row"
                                            alignItems="center"
                                            height={'100%'}
                                            width={'100%'}
                                        >
                                            {!dispatchData.isreadonly &&
                                                <div style={{width: '25px', height: '25px', paddingBottom: '25px'}}>
                                                    <IconButton
                                                        className={styles.submitButton}
                                                        onClick={() => handleTimeEntryAdd()}
                                                        size="small">
                                                        <Add/>
                                                    </IconButton>
                                                </div>
                                            }
                                            {getTimeEntryCardDetails()}
                                        </Grid>
                                    </Box>
                                </AccordionDetails>
                            </Accordion>
                        </>
                    )
                }
                else if (dispatch.sectionname === '*CUSTOMERSIGNOFF*') {
                    // console.log(dispatch)
                    const companyRepMenuOptions = dispatch?.companyreplist?.map(item => (
                        <MenuItem key={item.companyrepid} value={item.companyrep}>
                            {item.companyrep}
                        </MenuItem>
                    ))
                    // console.log(companyRepMenuOptions)

                    return (
                        <Accordion disableGutters={true}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant="h6">Customer Sign Off</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Grid
                                        container
                                        border={0}
                                        direction="row"
                                        alignItems="center"
                                        height={'100%'}
                                        width={'100%'}
                                    >
                                        {getSignOffAccordionDetails(dispatch?.companyreplist, dispatch?.jobtypelist, companyRepMenuOptions)}
                                    </Grid>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    )
                }
                else if (dispatch.sectionname === '*CUSTOMERSIGNOFF2*') {
                    return (
                        <Accordion disableGutters={true}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant="h6">Customer Sign Off</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Grid
                                        container
                                        border={0}
                                        direction="row"
                                        alignItems="center"
                                        height={'100%'}
                                        width={'100%'}
                                    >
                                        {getSignOffAccordionDetails2(dispatch?.companyreplist, dispatch?.jobtypelist)}
                                    </Grid>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    )
                }
                else {
                    return (
                        <Accordion disableGutters={true}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel1a-content"
                                id="panel1a-header"
                            >
                                <Typography variant={'h6'}>{dispatch.sectionname}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Box>
                                    <Grid
                                        container
                                        border={0}
                                        direction="row"
                                        alignItems="center"
                                        height={'100%'}
                                        width={'100%'}
                                    >
                                        {getAccordionDetails(
                                            dispatch.sectionname,
                                            dispatch.sectiondata
                                        )}
                                    </Grid>
                                </Box>
                            </AccordionDetails>
                        </Accordion>
                    )
                }
            })
        }
    }

    const handlePhotoDelete = (e, item) => {
        console.log(item)
        setDialogObjPhoto({
            msg: 'Are you sure you want to delete "' + item.name + '"?',
            name: item.name,
            id: item.id
        })
    }

    const handlePhotoDeleteConfirm = async () => {
        const finalData = [...photos]
        const itsIt = finalData.filter((item) => item.id !== dialogObjPhoto.id)
        console.log(itsIt)
        setPhotos(itsIt)
        if (!networkOnline) {
            var oPhotoIds = [...offlinePhotoIds]
            oPhotoIds.push(dialogObjPhoto.id)
            setOfflinePhotoIds(oPhotoIds)
        }
        else {
            deleteTempPhoto(dialogObjPhoto.id)
        }

        closeDialog()
        setSyncServer(syncServer+1)
    }

    const handleEquipmentAdd = () => {
        setReloadForm(reloadForm + 1)
        setGridParams(null)
        setIsFormShowing(true)
    }

    const handleEquipmentDelete = (equipt) => {
        console.log(equipt)
        setDialogObj({
            msg: 'Are you sure you want to delete "' + equipt.equipment + '"?',
            id: Number(equipt.equipmentid)
        })
    }

    const handleEquipmentDeleteConfirm = () => {
        console.log(equipmentData)
        const finalData = [...equipmentData]
        const itsIt = finalData.filter((item) => item.equipmentid !== dialogObj.id)
        setEquipmentData(itsIt)
        closeDialog()
        setSyncServer(syncServer+1)
    }

    const closeDialog = () => {
        setDialogObjPhoto({
            msg: '',
            name: '',
            id: 0
        })
        setDialogObj({
            msg: '',
            id: 0
        })
        setDialogTimeEntryObj({
            msg: '',
            starttravel: new Date(),
            employeeid: 0
        })
        setDialogMsg("")
    }

    const getTempPhotos = (dispatchsendid, includeimagedata) => {
        if (networkOnline) {
            const body = {
                "dispatchsendid": dispatchsendid,
                "guid": userGuid,
                "includeimagedata": includeimagedata,
            }

            axios.post(`dispatchtempphoto`, body).then((response) => {
                const dataJson = JSON.parse(response.data.jsonString)
                var photoData = []
                console.log(dataJson)
                if (dataJson && dataJson?.photos && dataJson?.photos?.length > 0) {
                    const newData = dataJson.photos?.map((p: any, i) => {
                        // console.log('Image Id: ' + p.id)
                        // console.log('Image Length: ' + p.photo.length)
                        return { imageData: p.photo, id: p.id, name: p.filename, size: p.filesize, type: p.filetype }
                    })
                    // console.log(newData)
                    setPhotos(newData)
                    photoData = newData
                }
                else {
                    setPhotos([])
                }


                const photoGuid = userGuid + '-photos'
                const photoSectionData = JSON.stringify(
                    {
                        "sectionname": "*PHOTOS*",
                        "data": photoData.map((photo) => { return { photo: photo.imageData, id: photo.id, filename: photo.name, filesize: photo.size, filetype: photo.type }}),
                    }
                )

                // console.log(photoSectionData)
                addDBRecord(photoGuid, photoSectionData).then(
                    id => {
                        // console.log('ID Generated: ', id);
                        // if (serverSave && networkOnline) {
                        //     saveDBPhotosRec(photoGuid)
                        // }
                    },
                    error => {
                        // if (serverSave && networkOnline) {
                        //     saveDBPhotosRec(photoGuid)
                        // }
                        console.log(error);
                    }
                )


                // setWritePhotoData(true)
                // writeDatabaseRecordForPhotos(false)
            })
        }
    }

    const deleteTempPhoto = (id) => {
        const body = {
            "dispatchsendid": dispatchData.dispatchsendid,
            "guid": userGuid,
            "photos":[{
                "id": id,
            }]
        }

        axios.delete(`dispatchtempphoto`, {data: body})
    }

    const uploadTempPhoto = (newPhotos: any) => {
        // console.log(newPhotos)
        const body = {
            "dispatchsendid": dispatchData.dispatchsendid,
            "guid": userGuid,
            "photos":newPhotos.map(photo => {
                return {
                    "id": photo.id,
                    "photo": photo.imageData,
                    "filename": photo.name,
                    "filetype": photo.type,
                    "filesize": photo.size
                }
            })
        }
        console.log(body)

        axios.put(`dispatchtempphoto`, body)
    }


    const onLogoDrop = async (files: File[]) => {
        // const options = {
        //     maxSize: 1,
        //     maxWidthOrHeight: 1100,
        //     useWebWorker: true,
        // }
        setLoadingBackdrop(true)
        for (const fileToUpload of files) {
            // var compressedFile;
            const fileReader = new FileReader()

            fileReader.onloadend = async function (event) {
                const data = event.target.result as string
                const unique_id = uuid();
                // Get first 8 characters using slice
                const id = unique_id.slice(0, 8)

                // path: "cubs (1).png"
                // lastModified: 1657308022556
                // lastModifiedDate: Fri Jul 08 2022 14:20:22 GMT-0500 (Central Daylight Time) {}
                // name: "cubs (1).png"
                // size: 5324
                // type: "image/png"
                const myImageData = data.split(';base64,')[1]
                // var base64Check = '/^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/';
                // var base64regex = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

                // console.log(base64regex.test(myImageData))
                // console.log('Compressed Image: ' + myImageData.length)

                // const compressedFileString = await compressedFile.text();
                const newPhoto = {
                    id: id,
                    imageData: myImageData,
                    // imageDataBlob: compressedFileString,
                    name: fileToUpload.name,
                    size: fileToUpload.size,
                    // size: myImageData.length,
                    type: fileToUpload.type,
                }

                // if (networkOnline) {
                //     uploadTempPhoto(newPhotos)
                // }

                // console.log(newPhotos)
                setPhotos(prevState => [...prevState, newPhoto])
                setSyncServer(syncServer+1)
                setLoadingBackdrop(false)
            }

            new Compressor(fileToUpload, {
                quality: 0.4,
                success(result) {
                    // compressedFile = result
                    fileReader.readAsDataURL(result)
                },
                error(err) {
                    console.log(err.message);
                },
            });
            // const compressedFile = await imageCompression(fileToUpload, options)
            // fileReader.readAsDataURL(compressedFile)
        }
    }

    const getPhotoAccordionDetails = () => {
        // console.log(photos)
        return (
            <>
                <Grid container spacing={1}>
                    {!dispatchData.isreadonly &&
                        <Grid item xs={12}>
                            <Dropzone onDrop={onLogoDrop}>
                                {({
                                      getRootProps,
                                      getInputProps,
                                      isDragActive,
                                      isDragAccept,
                                      isDragReject,
                                      acceptedFiles,
                                      fileRejections,
                                  }) => (
                                    <div style={{width: '25px', height: '25px'}} {...getRootProps()}
                                         className={styles.dropzone}>
                                        <input {...getInputProps()} />
                                        <AddAPhotoIcon style={{width: '100%', height: '100%'}}/>
                                    </div>
                                    
                                )}
                            </Dropzone>
                        </Grid>
                    }
                    <Grid item xs={12}>
                        {photos &&
                            <ImageList sx={{ width: 300, height: 250, alignItems: 'center', overflow: 'auto', }}  cols={1} gap={8} rowHeight={200} style={{alignItems: 'center'}}>
                                {photos.map((item) => (
                                    <Card sx={{ width: 300, height: 250, alignItems: 'center', }}>
                                        {!dispatchData.isreadonly &&
                                            <CardHeader
                                                action={
                                                    <IconButton onClick={(e) => {handlePhotoDelete(e, item)}} aria-label="settings">
                                                    <ClearIcon  />
                                                    </IconButton>
                                                }
                                                // title={item.name}
                                                subheader={item.name}
                                            />
                                        }
                                        {dispatchData.isreadonly &&
                                            <CardHeader
                                                // title={item.name}
                                                subheader={item.name}
                                            />
                                        }
                                        <CardMedia
                                            style={{
                                                width: "auto",
                                                maxHeight: "250px",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: 'center'
                                            }}
                                            component="img"
                                            src={`data:image/png;base64,${item.imageData}`}
                                            alt=""
                                        />
                                    </Card>
                                ))}
                            </ImageList>
                        }
                    </Grid>
                </Grid>
            </>

        )
    }

    const getDocumentBlob = async (body: any) => {
        try {
            const response = await axios.post(`dispatchfiledownloadstream`, body, {
                responseType: 'blob'
            })
            return response.data as Blob
        } catch (error: any) {
            // When responseType is 'blob', error responses need to be parsed from blob
            if (error.response?.data instanceof Blob) {
                const errorText = await error.response.data.text();
                try {
                    const errorJson = JSON.parse(errorText);
                    throw new Error(errorJson.message || 'Failed to download file');
                } catch {
                    throw new Error(errorText || 'Failed to download file');
                }
            }
            throw error;
        }
    }

    const getDocumentObj = async (body: any) => {
        try {
            // console.log(body)
            const response = await axios.post(`gddispatchfiledownload`, body)// .then(responce => responce.data)
            // console.log(response.data)
            // console.log('before')

            const dataJson = JSON.parse(response.data.jsonString)
            console.log(dataJson.type)
            // console.log('after')
            // var contentType = 'image/png';
            // if (dataJson.fileext === 'png') {
            //     contentType = 'image/png'
            // } else if (dataJson.fileext === 'pdf') {
            //     contentType = 'application/pdf'
            // } else if (dataJson.fileext === 'jpeg' || dataJson.fileext === 'jpg') {
            //     contentType = 'image/jpeg'
            // } else if (dataJson.fileext === 'docx') {
            //     contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            // } else if (dataJson.fileext === 'xlsx') {
            //     contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            // } else if (dataJson.fileext === 'xls') {
            //     contentType = 'application/vnd.ms-excel'
            // }
            // // setWatchLogoData(dataJson.filedata)
            //
            // console.log(dataJson.filedata)
            // const byteCharacters = atob(dataJson.filedata)
            // const byteNumbers = new Array(byteCharacters.length);
            // for (let i = 0; i < byteCharacters.length; i++) {
            //     byteNumbers[i] = byteCharacters.charCodeAt(i);
            // }
            // const byteArray = new Uint8Array(byteNumbers);
            // const blob = new Blob([byteArray], {type: contentType});
            return dataJson
        }
        catch(err) {
            console.log(err)
        }
    }

    const getContentType = (fileext) => {
        var contentType =  'image/png'
        if (fileext === 'png') {
            contentType = 'image/png'
        } else if (fileext === 'pdf') {
            contentType = 'application/pdf'
        } else if (fileext === 'jpeg' || fileext === 'jpg') {
            contentType = 'image/jpeg'
        } else if (fileext === 'docx') {
            contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        } else if (fileext === 'xlsx') {
            contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        } else if (fileext === 'xls') {
            contentType = 'application/vnd.ms-excel'
        }
        return contentType
    }

    useEffect(() => {
        if (openViewer == false && watchLogoDataURL) {
            setOpenViewer(true)
        }
        else {
            URL.revokeObjectURL(watchLogoDataURL)
            setWatchLogoDataURL(null)
        }
    }, [watchLogoDataURL])

    useEffect(() => {
        if (openViewer == false && watchLogoDataURL) {
            URL.revokeObjectURL(watchLogoDataURL)
            setWatchLogoDataURL(null)
        }
    }, [openViewer])

    const handleDocumentListItemClick = async (
        event: React.MouseEvent<HTMLDivElement, MouseEvent>,
        item,
    ) => {
        event.stopPropagation()
        event.preventDefault()
        setDocumentData(item)

        getDocumentDBRecord(item.id).then((data) => {
            const data2 = data
            const url = window.URL.createObjectURL(data2.blobData);
            setWatchLogoDataURL(url);
            debugger
        })
    }

    const getDocumentAccordionDetails = (filelist) => {
        // id: file.Id,
        //     filename: file.Name,
        //     serverModified: dataJson.serverModified,
        //     filedata: dataJson.filedata,
        //     fileurl: url,
        //     fileext: dataJson.fileext
        return (
            <>
                <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
                    <List component="nav" aria-label="documents list" key={`docs-${documents.length}-${documentsLoading.length}`}>
                        {/* Downloaded documents */}
                        {documents && documents.length > 0 && documents.map((item, index) => (
                            <ListItemButton
                                key={`doc-${item.id}-${index}`}
                                onClick={(event) => handleDocumentListItemClick(event, item)}
                                sx={{
                                    '&:hover': {
                                        bgcolor: 'action.hover',
                                    }
                                }}
                            >
                                <ListItemIcon>
                                    <InsertDriveFileIcon />
                                </ListItemIcon>
                                <ListItemText
                                    primary={item?.filename}
                                    primaryTypographyProps={{
                                        noWrap: true,
                                        sx: { overflow: 'hidden', textOverflow: 'ellipsis' }
                                    }}
                                />
                            </ListItemButton>
                        ))}

                        {documentsLoading && documentsLoading.length > 0 && documentsLoading.map((item, index) => (
                            <ListItemButton
                                key={`loading-${item.id}-${index}`}
                                disabled
                                sx={{
                                    opacity: 0.7,
                                    cursor: 'default'
                                }}
                            >
                                <ListItemIcon>
                                    <CircularProgress size={24} />
                                </ListItemIcon>
                                <ListItemText
                                    primary={` ${item.name}`}
                                    secondary={item.progress ? `${(item.progress / 1024 / 1024).toFixed(2)} MB downloaded` : 'Starting...'}
                                    primaryTypographyProps={{
                                        noWrap: true,
                                        sx: {
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            fontStyle: 'italic',
                                            color: 'text.secondary'
                                        }
                                    }}
                                />
                            </ListItemButton>
                        ))}

                        {(!documents || documents.length === 0) && (!documentsLoading || documentsLoading.length === 0) && (
                            <ListItem>
                                <ListItemText
                                    primary="No documents available"
                                    primaryTypographyProps={{
                                        sx: {
                                            color: 'text.secondary',
                                            fontStyle: 'italic',
                                            textAlign: 'center'
                                        }
                                    }}
                                />
                            </ListItem>
                        )}
                    </List>
                </Box>
            </>

        )
    }

    const clearSignatureCustomerRep = () => {
        signCanvasCustomerRep.current.clear()
        setCustomerSigned(null)
        setSignCanvasCustomerBase64("")
    }

    const clearSignatureFieldRep = () => {
        setFieldSigned(null)
        signCanvasFieldRep.current.clear()
        setSignCanvasFieldBase64("")
    }

    const clearSignatureCompanyRep = () => {
        setCompanySigned(null)
        signCanvasCompanyRep.current.clear()
        setSignCanvasCompanyBase64("")
    }

    const getJobTypeOptions = (jobTypeList) => {
        return jobTypeList?.map(item => (
            <MenuItem key={item.jobtypeid} value={item.jobtype}>
                {item.jobtype}
            </MenuItem>
        ))
    }

    const getEmergencyCustomerTypeOptions = (customerList) => {
        return customerList?.map(item => (
            <MenuItem key={item.customerid} value={item.customer}>
                {item.customer}
            </MenuItem>
        ))
    }

    const getListOptions = (listOptions) => {
        return listOptions?.map(item => (
            <MenuItem key={item.jobtypeid} value={item.jobtype}>
                {item.jobtype}
            </MenuItem>
        ))
    }

    const getOptions = (companyRepList) => {
        return companyRepList?.map(item => (
            <MenuItem key={item.companyrepid} value={item.companyrep}>
                {item.companyrep}
            </MenuItem>
        ))
    }

    const getVehicleOptions = (vehiclelist) => {
        return vehiclelist?.map(item => (
            <MenuItem key={item.vehicleid} value={item.vehicle}>
                {item.vehicle}
            </MenuItem>
        ))
    }

    const handleJobTypeChange = (event, jobList) => {
        if (event) {
            setJobTypeActiveSelect(event.target.value as string)
            const selection = jobList?.find((item) => item.jobtype === event.target.value as string)
            if (selection) {
                setJobTypeActiveSelectId(selection.jobtypeid)
                setSyncServer(syncServer+1)
            }
        }
        else {
            const selection = jobList?.find((item) => item.jobtype === 'Scheduled')
            if (selection) {
                setJobTypeActiveSelect(selection.jobtype)
                setJobTypeActiveSelectId(selection.jobtypeid)
                setSyncServer(syncServer+1)
            }
        }
    }

    const handleEmergencyCustomerTypeChange = (event, customerList) => {
        if (event) {
            setEmergencyCustomerActiveSelect(event.target.value as string)
            const selection = customerList?.find((item) => item.customer === event.target.value as string)
            if (selection) {
                setEmergencyCustomerActiveSelectId(selection.customerid)
                setSyncServer(syncServer+1)
            }
        }
    }

    const handleEmployeeSelectChange = (event, repList) => {
        if (event.target.value && event.target.value.length > 0) {
            setEmployeeSelect(event.target.value as string)
            const selection = repList?.filter((item) => item.companyrep === event.target.value as string)
            if (selection && selection.length > 0) {
                setEmployeeSelectId(selection[0].companyrepid)
                setSyncServer(syncServer+1)
            }
        }
    }

    const onCommentChange = (e) => {
        setCommentText(e.target.value)
    }

    const onCustomerRepChange = (e) => {
        setCustomerRepActiveSelect(e.target.value)
    }

    const onCompanyRepChange = (e) => {
        setEmployeeSelect(e.target.value)
    }

    const onEmergencyCustomerNumberChange = (e) => {
        setEmergencyCustomerNumberActiveSelect(e.target.value)
    }

    const onEmergencyAddressChange = (e) => {
        console.log(e.target.value)
        setEmergencyAddressActiveSelect(e.target.value)
    }

    const onEmergencyCustomerChange = (e) => {
        setEmergencyCustomerActiveSelect(e.target.value)
    }

    const onFieldRepChange = (e) => {
        setFieldRepActiveSelect(e.target.value)
    }

    const onJobTypeChange = (e) => {
        setJobTypeActiveSelect(e.target.value)
    }

    const getSignOffAccordionDetails = (companyRepList, jobtypelist, companyRepMenuOptions) => {
        if (jobTypeActiveSelect.length <= 0) {
            const selection = jobtypelist?.find((item) => item.jobtype === 'Scheduled')
            if (selection) {
                setJobTypeActiveSelect(selection.jobtype)
                console.log(selection.jobtypeid)
                setJobTypeActiveSelectId(selection.jobtypeid)
            }
        }

        return (
            <Box sx={{height: '100%',width: '100%', bgcolor: 'background.paper' }}>
                <FormControl fullWidth style={{'paddingBottom': '20px'}}>
                    {dispatchData.isreadonly ?
                        <TextField
                            id="outlined-multiline-static"
                            label="Job Type"
                            defaultValue={jobTypeActiveSelect}
                            value={jobTypeActiveSelect}
                            fullWidth={true}
                            disabled={dispatchData.isreadonly}
                            onChange={onJobTypeChange}
                            style={{'paddingBottom': '20px'}}
                        />
                        :
                        <>
                            <InputLabel>Job Type*</InputLabel>
                            <Select
                                name="job"
                                label="Job Type"
                                defaultValue={jobTypeActiveSelect}
                                value={jobTypeActiveSelect}
                                size={'small'}
                                required={true}
                                variant="outlined"
                                onChange={(e) => { handleJobTypeChange(e, jobtypelist) }}
                            >
                                {getJobTypeOptions(jobtypelist)}
                            </Select>
                        </>
                    }
                </FormControl>

                <TextField
                    id="outlined-multiline-static"
                    label="Other Comments"
                    multiline
                    rows={4}
                    defaultValue={commentText}
                    fullWidth={true}
                    disabled={dispatchData.isreadonly}
                    onChange={onCommentChange}
                    onBlur={() => { setSyncServer(syncServer+1) }}
                    style={{'paddingBottom': '20px'}}
                />

                <FormControl fullWidth style={{'paddingBottom': '20px'}}>
                    <TextField
                        id="outlined-multiline-static"
                        label="Customer Rep"
                        defaultValue={customerRepActiveSelect}
                        value={customerRepActiveSelect}
                        fullWidth={true}
                        required={true}
                        disabled={dispatchData.isreadonly}
                        onChange={onCustomerRepChange}
                        onBlur={() => { setSyncServer(syncServer+1) }}
                        style={{'paddingBottom': '20px'}}
                    />
                </FormControl>

                {dispatchData.isreadonly ?
                    <>
                        <Typography variant="body2" gutterBottom>Employee</Typography>
                        <img height={'100px'} src={`data:image/png;base64,${customerSigned}`}
                             alt="Signature" style={{'paddingBottom': '20px'}}/>
                    </>
                    :
                    <>
                        {customerSigned
                            ?
                            <>
                                <Typography variant="body2" gutterBottom>Current Customer Signature</Typography>
                                <img height={'100px'} src={`data:image/png;base64,${customerSigned}`}
                                     alt="Signature"/>
                            </>
                            :
                            null
                        }
                        <SignatureCanvas onEnd={async () =>
                            {
                                const signCanvasCustomerRepFile = dataURLtoFile(signCanvasCustomerRep?.current?.getTrimmedCanvas().toDataURL('image/png'), 'signCanvasCustomerRep')
                                const fileReader = new FileReader()
                                fileReader.onloadend = function (event) {
                                }
                                fileReader.onload = function (event) {
                                    const data = event.target.result as string
                                    const dataSpit = data.split(';base64,')[1]
                                    console.log(dataSpit)
                                    setSignCanvasCustomerBase64(dataSpit)
                                    setSyncServer(syncServer+1)
                                }

                                new Compressor(signCanvasCustomerRepFile, {
                                    quality: 0.4,
                                    success(result) {
                                        fileReader.readAsDataURL(result)
                                    },
                                    error(err) {
                                        console.log(err.message);
                                    },
                                });
                            }
                        }
                            clearOnResize={false} canvasProps={{className: styles.sigPad}}
                            ref={signCanvasCustomerRep}
                        />
                        <button className={styles.buttons} onClick={clearSignatureCustomerRep}>
                            Clear
                        </button>
                    </>
                }

                <FormControl fullWidth style={{'paddingBottom': '20px'}}>
                    {dispatchData.isreadonly ?
                        <TextField
                            id="outlined-multiline-static"
                            label="Employee"
                            defaultValue={employeeSelect}
                            value={employeeSelect}
                            fullWidth={true}
                            required={true}
                            disabled={dispatchData.isreadonly}
                            onChange={onCompanyRepChange}
                            style={{'paddingBottom': '20px'}}
                        />
                        :
                        <>
                            <InputLabel>Employee*</InputLabel>
                            <Select
                                name="equipment"
                                label="Employee"
                                id="employee-select"
                                defaultValue={employeeSelect}
                                value={employeeSelect}
                                size={'small'}
                                required={true}
                                variant="outlined"
                                onChange={(e) => { handleEmployeeSelectChange(e, companyRepList) }}
                            >
                                {companyRepMenuOptions}
                            </Select>
                        </>
                    }

                </FormControl>
                {dispatchData.isreadonly ?
                    <>
                        <Typography variant="body2" gutterBottom>Employee</Typography>
                        <img height={'100px'} src={`data:image/png;base64,${companySigned}`}
                             alt="Signature"/>
                    </>
                    :
                    <>
                        {companySigned
                            ?
                            <>
                                <Typography variant="body2" gutterBottom>Current Employee Signature</Typography>
                                <img height={'100px'} src={`data:image/png;base64,${companySigned}`}
                                     alt="Signature"/>
                            </>
                            :
                            null
                        }
                        <SignatureCanvas onEnd={async () =>
                        {
                            const signCanvasCompanyRepFile = dataURLtoFile(signCanvasCompanyRep?.current?.getTrimmedCanvas().toDataURL('image/png'), 'signCanvasCompanyRep')
                            const fileReader = new FileReader()
                            fileReader.onloadend = function (event) {}
                            fileReader.onload = function (event) {
                                const data = event.target.result as string
                                const dataImage = data.split(';base64,')[1]
                                setSignCanvasCompanyBase64(dataImage)
                                setSyncServer(syncServer+1)
                            }

                            new Compressor(signCanvasCompanyRepFile, {
                                quality: 0.4,
                                success(result) {
                                    fileReader.readAsDataURL(result)
                                },
                                error(err) {
                                    console.log(err.message);
                                },
                            });
                        }}
                                         clearOnResize={false} canvasProps={{className: styles.sigPad}}
                                         ref={signCanvasCompanyRep}
                        />
                        <button className={styles.buttons} onClick={clearSignatureCompanyRep}>
                            Clear
                        </button>
                    </>
                }

            </Box>
        )
    }

    const handleFieldRepNotOnSite = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFieldRepNotOnSite(event.target.checked);
    }

    const getSignOffAccordionDetails2 = (companyRepList, jobtypelist) => {
        // console.log(jobTypeActiveSelect)
        // console.log(jobTypeActiveSelectId)
        if (jobTypeActiveSelect.length <= 0) {
            const selection = jobtypelist?.find((item) => item.jobtype === 'Scheduled')
            if (selection) {
                setJobTypeActiveSelect(selection.jobtype)
                console.log(selection.jobtypeid)
                setJobTypeActiveSelectId(selection.jobtypeid)
            }
        }

        return (
            <Box sx={{height: '100%',width: '100%', bgcolor: 'background.paper' }}>
                <TextField
                    id="outlined-multiline-static"
                    label="Other Comments"
                    multiline
                    rows={4}
                    defaultValue={commentText}
                    fullWidth={true}
                    disabled={dispatchData.isreadonly}
                    onChange={onCommentChange}
                    style={{'paddingBottom': '20px'}}
                />

                <FormControl fullWidth style={{'paddingBottom': '20px'}}>
                    <TextField
                        id="outlined-multiline-static"
                        label="Employee"
                        defaultValue={customerRepActiveSelect}
                        value={customerRepActiveSelect}
                        fullWidth={true}
                        required={true}
                        disabled={dispatchData.isreadonly}
                        onChange={onCustomerRepChange}
                        style={{'paddingBottom': '20px'}}
                    />
                </FormControl>

                {dispatchData.isreadonly ?
                    <>
                        <Typography variant="body2" gutterBottom>Employee</Typography>
                        <img height={'100px'} src={`data:image/png;base64,${customerSigned}`}
                             alt="Signature" style={{'paddingBottom': '20px'}}/>
                    </>
                    :
                    <>
                        {customerSigned
                            ?
                            <>
                                <Typography variant="body2" gutterBottom>Current Employee Signature</Typography>
                                <img height={'100px'} src={`data:image/png;base64,${customerSigned}`}
                                     alt="Signature"/>
                            </>
                            :
                            null
                        }
                        <SignatureCanvas onEnd={async () =>
                        {
                            const signCanvasCustomerRepFile = dataURLtoFile(signCanvasCustomerRep?.current?.getTrimmedCanvas().toDataURL('image/png'), 'signCanvasCustomerRep')
                            const fileReader = new FileReader()
                            fileReader.onloadend = function (event) {}
                            fileReader.onload = function (event) {
                                const data = event.target.result as string
                                setSignCanvasCustomerBase64(data.split(';base64,')[1])
                            }

                            new Compressor(signCanvasCustomerRepFile, {
                                quality: 0.4,
                                success(result) {
                                    fileReader.readAsDataURL(result)
                                },
                                error(err) {
                                    console.log(err.message);
                                },
                            });
                            // fileReader.readAsDataURL(compressedFile)
                        }
                        }
                                         clearOnResize={false} canvasProps={{className: styles.sigPad}}
                                         ref={signCanvasCustomerRep}
                        />
                        <button className={styles.buttons} onClick={clearSignatureCustomerRep}>
                            Clear
                        </button>
                    </>
                }

                <FormControl fullWidth style={{'paddingBottom': '20px'}}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name={'fieldreponsite'}
                                defaultChecked={false}
                                onChange={(e) => {handleFieldRepNotOnSite(e)}}
                                checked={fieldRepNotOnSite}
                                disabled={dispatchData.isreadonly}
                                color="primary"
                            />
                        }
                        label="Field Rep Not OnSite"
                    />
                </FormControl>

                <FormControl fullWidth style={{'paddingBottom': '20px'}}>
                    <TextField
                        id="outlined-multiline-static"
                        label="Field Representative"
                        defaultValue={fieldRepActiveSelect}
                        value={fieldRepActiveSelect}
                        fullWidth={true}
                        required={false}
                        disabled={dispatchData.isreadonly}
                        onChange={onFieldRepChange}
                        style={{'paddingBottom': '20px'}}
                    />
                </FormControl>

                {dispatchData.isreadonly ?
                    <>
                        <Typography variant="body2" gutterBottom>Field Representative</Typography>
                        <img height={'100px'} src={`data:image/png;base64,${fieldSigned}`}
                             alt="Signature" style={{'paddingBottom': '20px'}}/>
                    </>
                    :
                    <>
                        {fieldSigned
                            ?
                            <>
                                <Typography variant="body2" gutterBottom>Current Field Representative Signature</Typography>
                                <img height={'100px'} src={`data:image/png;base64,${fieldSigned}`}
                                     alt="Signature"/>
                            </>
                            :
                            null
                        }
                        <SignatureCanvas onEnd={async () =>
                        {
                            const signCanvasFieldRepFile = dataURLtoFile(signCanvasFieldRep?.current?.getTrimmedCanvas().toDataURL('image/png'), 'signCanvasFieldRep')
                            const fileReader = new FileReader()
                            fileReader.onloadend = function (event) {}
                            fileReader.onload = function (event) {
                                const data = event.target.result as string
                                setSignCanvasFieldBase64(data.split(';base64,')[1])
                            }
                            new Compressor(signCanvasFieldRepFile, {
                                quality: 0.4,
                                success(result) {
                                    fileReader.readAsDataURL(result)
                                },
                                error(err) {
                                    console.log(err.message);
                                },
                            });
                        }
                        }
                                         clearOnResize={false} canvasProps={{className: styles.sigPad}}
                                         ref={signCanvasFieldRep}
                        />
                        <button className={styles.buttons} onClick={clearSignatureFieldRep}>
                            Clear
                        </button>
                    </>
                }
            </Box>
        )
    }

    const getEmergencyAccordionDetails = (customerList) => {

        return (
            <Box sx={{height: '100%',width: '100%', bgcolor: 'background.paper' }}>

                <FormControl fullWidth style={{'paddingBottom': '20px'}}>
                    {dispatchData.isreadonly ?
                        <TextField
                            id="outlined-multiline-static"
                            label="Customer"
                            defaultValue={emergencyCustomerActiveSelect}
                            value={emergencyCustomerActiveSelect}
                            fullWidth={false}
                            disabled={dispatchData.isreadonly}
                            onChange={onEmergencyCustomerChange}
                            style={{'paddingBottom': '20px'}}
                        />
                        :
                        <>
                            <InputLabel>Customer*</InputLabel>
                            <Select
                                name="customer"
                                label="Customer"
                                defaultValue={emergencyCustomerActiveSelect}
                                value={emergencyCustomerActiveSelect}
                                size={'small'}
                                required={false}
                                variant="outlined"
                                onBlur={() => {setSyncServer(syncServer+1)}}
                                onChange={(e) => { handleEmergencyCustomerTypeChange(e, customerList) }}
                            >
                                {getEmergencyCustomerTypeOptions(customerList)}
                            </Select>
                        </>
                    }
                </FormControl>
                <FormControl fullWidth style={{'paddingBottom': '0px'}}>
                    <TextField
                        id="outlined-multiline-static"
                        label="Customer Number"
                        defaultValue={emergencyCustomerNumberActiveSelect}
                        value={emergencyCustomerNumberActiveSelect}
                        fullWidth={true}
                        required={false}
                        disabled={dispatchData.isreadonly}
                        onChange={onEmergencyCustomerNumberChange}
                        onBlur={() => { setSyncServer(syncServer+1) }}
                        style={{'paddingBottom': '20px'}}
                    />
                </FormControl>
                <FormControl fullWidth >
                    <TextField
                        id="outlined-multiline-static"
                        label="Address"
                        defaultValue={emergencyAddressActiveSelect}
                        value={emergencyAddressActiveSelect}
                        fullWidth={true}
                        required={false}
                        disabled={dispatchData.isreadonly}
                        onChange={onEmergencyAddressChange}
                        onBlur={() => { setSyncServer(syncServer+1) }}
                        style={{'paddingBottom': '20px'}}
                    />
                </FormControl>
            </Box>
        )
    }

    const handleTimeEntryAdd = () => {
        setReloadTEForm(reloadTEForm + 1)

        if (timeEntries && timeEntries.length) {
            console.log(timeEntries[timeEntries.length - 1])
            setGridParams(timeEntries[timeEntries.length - 1])
        }
        else {
            setGridParams(null)
        }
        setIsTEFormShowing(true)
        setTEEdit(false)
    }

    const handleTimeEntryDelete = (e, entry) => {
        e.stopPropagation()
        e.preventDefault()

        // console.log(entry)

        setDialogTimeEntryObj({
            msg: 'Are you sure you want to delete the time card for "' + entry.employee + '"?',
            starttravel: entry.starttravel,
            employeeid: entry.employeeid
        })
    }

    const handleTimeEntryDeleteConfirm = async () => {
        const finalData = [...timeEntries]
        const itsIt = finalData.filter((item) => item.employeeid !== dialogTimeEntryObj.employeeid)
        console.log(itsIt)
        setTimeEntries(itsIt)
        closeDialog()
        setSyncServer(syncServer+1)
    }

    const handleTimeEntryEdit = (entry) => {
        if (!dispatchData.isreadonly) {
            console.log(entry)
            setReloadTEForm(reloadTEForm + 1)
            setGridParams(entry)
            setIsTEFormShowing(true)
            setTEEdit(true)
        }
    }

    const getTimeEntryCardDetails = () => {
        return timeEntries.map((entry) => {
            return (
                <>
                    <Card sx={{ width: '100%', marginBottom: '15px'}} onClick={(e) => { handleTimeEntryEdit(entry) }}>
                        <CardContent>
                            <Grid
                                container
                                border={0}
                                direction="row"
                                alignItems="top"
                                height={'100%'}
                                width={'100%'}
                            >
                                <>
                                    <Grid item border={0} xs={10}>
                                        <Typography variant="body1" gutterBottom>
                                            <>
                                                {!dispatchData?.isreadonly &&
                                                    <IconButton aria-label="settings" onClick={(e) => {
                                                        handleTimeEntryEdit(entry)
                                                    }}>
                                                        <EditIcon/>
                                                    </IconButton>
                                                }
                                            </>
                                            {entry.employee}
                                        </Typography>
                                    </Grid>
                                    {!dispatchData.isreadonly &&
                                        <Grid item border={0} xs={2}>
                                            <IconButton aria-label="settings" onClick={(e) => {
                                                handleTimeEntryDelete(e, entry)
                                            }}>
                                                <DeleteIcon/>
                                            </IconButton>
                                        </Grid>
                                    }
                                </>
                                <>
                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            Travel Start:
                                        </Typography>
                                    </Grid>

                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            {dayjs(entry.starttravel).format('MM/DD/YYYY hh:mmA')}
                                        </Typography>
                                    </Grid>
                                </>
                                <>
                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            On Job:
                                        </Typography>
                                    </Grid>

                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            {dayjs(entry.onjob).format('MM/DD/YYYY hh:mmA')}
                                        </Typography>
                                    </Grid>
                                </>
                                <>
                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            Leave Job:
                                        </Typography>
                                    </Grid>

                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            {dayjs(entry.leavejob).format('MM/DD/YYYY hh:mmA')}
                                        </Typography>
                                    </Grid>
                                </>
                                <>
                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            Travel End:
                                        </Typography>
                                    </Grid>

                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            {dayjs(entry.endtravel).format('MM/DD/YYYY hh:mmA')}
                                        </Typography>
                                    </Grid>
                                </>
                                <>
                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            Vehicle:
                                        </Typography>
                                    </Grid>

                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            {entry.vehicle ? entry.vehicle : 'N/A'}
                                        </Typography>
                                    </Grid>
                                </>
                                <>
                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            Missing Lunch:
                                        </Typography>
                                    </Grid>

                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            {entry.lunch ? 'Yes' : 'No'}
                                        </Typography>
                                    </Grid>
                                </>
                            </Grid>
                        </CardContent>
                    </Card>
                </>
            )
        })
    }

    const getEquiptmentCardDetails = () => {
        return equipmentData.map((equipt) => {
            return (
                <>
                    <Card sx={{ width: '100%', marginBottom: '15px'}}>
                        <CardContent>
                            <Grid
                                container
                                border={0}
                                direction="row"
                                alignItems="center"
                                height={'100%'}
                                width={'100%'}
                            >

                                <>
                                    <Grid item border={0} xs={10}>
                                        <Typography variant="body1">
                                            {equipt.equipment}
                                        </Typography>
                                    </Grid>
                                    {!dispatchData.isreadonly &&
                                        <Grid item border={0} xs={2}>
                                            <IconButton aria-label="settings" onClick={(e) => { handleEquipmentDelete(equipt) }}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>
                                    }
                                </>
                                <>
                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            Quantity:
                                        </Typography>
                                    </Grid>

                                    <Grid item border={0} xs={6}>
                                        <Typography variant="body2" gutterBottom>
                                            {equipt.quantity}
                                        </Typography>
                                    </Grid>
                                </>
                            </Grid>
                        </CardContent>
                    </Card>
                </>
            )
        })
    }

    const getAccordionDetails = (name: string, sectionData: any) => {
        if (sectionData && sectionData.length > 0) {
            return sectionData.map((section) => {
                if (section.label === '*MAP*') {
                    return getMap(section.value)
                } else if (section.label && section.value) {
                    return (
                        <>
                            <Grid item border={0} xs={8}>
                                <Typography variant="body2" gutterBottom>
                                    {section.label}
                                </Typography>
                            </Grid>

                            <Grid item border={0} xs={4}>
                                <Typography variant="body2" gutterBottom>
                                    {section.value}
                                </Typography>
                            </Grid>
                        </>
                    )
                } else if (section.label) {
                    return (
                        <>
                            <Grid item border={0} xs={12}>
                                <Typography variant="body2" gutterBottom>
                                    {section.label}
                                </Typography>
                            </Grid>
                        </>
                    )
                } else if (section.value) {
                    return (
                        <>
                            <Grid item border={0} xs={12}>
                                <Typography variant="body2" gutterBottom>
                                    {section.value}
                                </Typography>
                            </Grid>
                        </>
                    )
                }
            })
        }
    }

    const getAppBarMessage = () => {
        if (dispatchData && dispatchData.status === 'failure') {
            setTitleMessage(dispatchData.message)
        }
        else if (dispatchData && dispatchData.title) {
            setTitleMessage(dispatchData.title)
        }
        else {
            setTitleMessage('Loading Schedule')
        }
    }

    const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }

        setSnackbarOpen({ open: false, message: ""  });
    }

    const submitTempForm = () => {
        // if (!networkOnline) {
        //     setSnackbarOpen( { open: true, message: "Data connection error - Work order is currently working in offline mode." })
        // }
        // else {
        //     setLoadingBackdrop(true)
        //     const sendTempSavePromise = sendTempSave()
        //     if (sendTempSavePromise !== null) {
        //         sendTempSavePromise.then(
        //             (resp) => {
        //                 setLoadingBackdrop(false)
        //                 if (resp && resp.data) {
        //                     const parsedData = JSON.parse(resp.data.jsonString)
        //                     if (parsedData.status === 'success') {
        //                         setDisableSubmit(true)
        //                     }
        //                     // const [isFormShowing, setIsFormShowing] = useState(false)
        //                     setSnackbarOpen( { open: true, message: parsedData.message })
        //                 }
        //                 else {
        //                     setSnackbarOpen( { open: true, message: "Unexpected Error - Please try again." })
        //                 }
        //             }
        //         )
        //     }
        // }
    }

    const submitForm = () => {
        console.log('submit form')
        if (!customerRepActiveSelect || customerRepActiveSelect.length <= 0) {
            setLoadingBackdrop(false)
            var message = "Missing a valid company representative."
            if (customerSignOff2) {
                message = "Missing a valid employee."
            }
            setDialogMsg(message)
        }
        else if (signCanvasCustomerBase64.length <= 0) {
            setLoadingBackdrop(false)
            var message = "Missing a valid company representative signature."
            if (customerSignOff2) {
                message = "Missing a valid employee signature."
            }
            setDialogMsg(message)
        }
        else if (!customerSignOff2 && (!employeeSelect || employeeSelect.length <= 0)) {
            setLoadingBackdrop(false)
            setDialogMsg("Missing a valid Employee.")
        }
        else if (!customerSignOff2 && signCanvasCompanyBase64.length <= 0) {
            setLoadingBackdrop(false)
            setDialogMsg("Missing a valid Employee Signature.")
        }
        else if (!customerSignOff2 && timeEntries?.length <= 0) {
            setLoadingBackdrop(false)
            setDialogMsg("Missing a valid time entry. Please enter at least 1 time entry record.")
        }
        else if (!networkOnline) {
            setLoadingBackdrop(false)
            setSnackbarOpen( { open: true, message: "Data connection error - Work order is currently working in offline mode." })
        }
        else {
            setLoadingBackdrop(true)
            sendSave().then(
                (resp) => {
                    setLoadingBackdrop(false)
                    if (resp && resp.data) {
                        const parsedData = JSON.parse(resp.data.jsonString)

                        const customerSign = signCanvasCustomerBase64
                        const companySign = signCanvasCompanyBase64

                        if (parsedData.status === 'success') {
                            setDisableSubmit(true)
                            // var newDataReadOnly = {...dispatchData}
                            // newDataReadOnly.isreadonly = true
                            // newDataReadOnly.title = newDataReadOnly.title + ' (readonly)'
                            // console.log(newDataReadOnly)
                            // setDispatchData(newDataReadOnly)
                            getDispatchData()
                            // setCustomerSigned(customerSign)
                            // setCompanySigned(companySign)
                        }
                        setSnackbarOpen( { open: true, message: parsedData.message })
                    }
                    else {
                        setSnackbarOpen( { open: true, message: "Unexpected Error - Please try again." })
                    }
                }
            )
        }
    }

    const openMap = (lat, lng) => {
        https://www.google.com/maps/dir/?api=1
        window.open("https://maps.google.com?q="+ lat +"," + lng );
    }

    const getMimeType = (fileext) => {
        fileext = fileext.replace(/\./g, '');
        var contentType = 'image/png';
        if (fileext === 'png') {
            contentType = 'image/png'
        }
        else if (fileext === 'pdf') {
            contentType = 'application/pdf'
        }
        else if (fileext === 'jpg' || fileext === 'jpeg') {
            contentType = 'image/jpeg'
        }
        else if (fileext === 'docx') {
            contentType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        }
        else if (fileext === 'xlsx') {
            contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        }
        else if (fileext === 'xls') {
            contentType = 'application/vnd.ms-excel'
        }
        return contentType
    }

    const getMap = (mapValue: string) => {
        const center = mapValue.split(',').reduce(
            (acc: any, value, i) => {
                if (i === 0) {
                    acc.lat = Number(value)
                } else {
                    acc.lng = Number(value)
                }
                return acc
            },
            { lat: 0, lng: 0 }
        )


        return  (center && center.lat > 0 ? (
                    <Grid item height={'100%'} width={'100%'}>
                        <Wrapper apiKey={mapapikey}>
                            <MapComponent center={center} zoom={10} />
                        </Wrapper>
                    </Grid>
                )
                :
                ( <></> )
        )
    }
    const openWindow = (documentData) => {
        var urlTOOpen = '/filesystem/pdfpage/' + documentData.id + '/' + 1
        var CryptoJS = require("crypto-js");
        var encriptedString = CryptoJS.AES.encrypt(JSON.stringify({
            id: documentData.id,
            fileext: documentData.fileext,
            nodownload: true,
            readonly: true,
        }), secretkey).toString();

        localStorage.setItem('pdfopen-' + documentData.id + '-' + 1, encriptedString)
        window.open(urlTOOpen)
    }

    return (
        <>
            <AppBar position="absolute" className={cn(styles.appBar, styles.shift)}>
                <Typography style={{display: 'inline-block'}} variant="h6" color="primary" component="div" align="center">
                    {titleMessage}
                    <Typography textAlign="right" fontSize={'11px'} style={{display: 'inline-block', paddingLeft: '2px'}} variant="caption" color="textDisabled" component="div" >
                        {version}
                    </Typography>
                </Typography>
            </AppBar>
            <>
                {watchLogoDataURL && (
                    <Grid item xs={6} className={styles.selectcontrol}>
                        <>
                            <Dialog
                                open={openViewer}
                                fullWidth={true}
                                maxWidth="xl"
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogContent>
                                    <div className="PDF-viewer">
                                        <PdfViewerComponent
                                            readonly={true}
                                            document={watchLogoDataURL}
                                            item={documentData}
                                            woid={dispatchDataHold?.woid}
                                            generalformsgoogledriveid={documentData.id}
                                        />
                                    </div>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={() => {
                                        setOpenViewer(false)
                                        setDocumentData(null)
                                        setWatchLogoDataURL(null)
                                    }}>Cancel</Button>
                                    <Button onClick={() => {
                                        setOpenViewer(false)
                                        openWindow(documentData)
                                    }} disabled={!networkOnline}>{networkOnline ? 'Open Window' : 'Open Window - Offline'}</Button>
                                    {/*<Button>Save</Button>*/}
                                </DialogActions>
                            </Dialog>
                        </>
                    </Grid>
                )}
            </>
            <>
                <Snackbar
                    open={snackbarOpen.open}
                    autoHideDuration={4000}
                    onClose={handleClose}
                    anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
                >
                    <Alert severity="success">
                        {snackbarOpen.message}
                    </Alert>
                </Snackbar>
            </>
            <>
                <Dialog
                    open={dialogObj.msg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogObj.msg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Cancel</Button>
                        <Button onClick={handleEquipmentDeleteConfirm}>DELETE</Button>
                    </DialogActions>
                </Dialog>
            </>
            <>
                <Dialog
                    open={dialogTimeEntryObj.msg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogTimeEntryObj.msg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Cancel</Button>
                        <Button onClick={handleTimeEntryDeleteConfirm}>DELETE</Button>
                    </DialogActions>
                </Dialog>
            </>
            <>
                <Dialog
                    open={dialogObjPhoto.msg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogObjPhoto.msg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Cancel</Button>
                        <Button onClick={handlePhotoDeleteConfirm}>DELETE</Button>
                    </DialogActions>
                </Dialog>
            </>

            <>
                <Dialog
                    open={dialogMsg.length > 0}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {dialogMsg}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialog}>Ok</Button>
                    </DialogActions>
                </Dialog>
            </>
            <EquipmentForm
                isOpen={isFormShowing}
                setIsOpen={setIsFormShowing}
                reloadForm={reloadForm}
                equipmentlist={equipmentFormData}
                equipmentData={equipmentData}
                setEquipmentData={setEquipmentData}
                reloadData={syncServer}
                setReloadData={setSyncServer}
            />
            <div className={styles.root}>
                <Container>
                    <Box>
                        <Grid
                            container
                            border={0}
                            direction="row"
                            alignItems="center"
                            height={'100%'}
                            width={'100%'}
                        >
                            {getMainLabels()}
                        </Grid>
                    </Box>
                    <Box>{getSectionsAccordion()}</Box>
                    <LoadingBackdrop open={loadingBackdrop} />
                    {!disableSubmit && dispatchData && !dispatchData.isreadonly && dispatchData.sectiondata && dispatchData.sectiondata.length > 0 &&
                        <Button type="submit" onClick={submitForm} className={styles.buttons} style={{'paddingTop': '20px'}}>
                            Submit
                        </Button>
                    }
                    {(!dispatchData || dispatchData === undefined ) &&
                        <div style={{display: 'flex', justifyContent: 'center'}}>
                            <CircularProgress />
                        </div>
                    }
                    {/*{(dispatchData && dispatchData?.length === 0) &&*/}
                    {/*    <div style={{display: 'flex', justifyContent: 'center'}}>*/}
                    {/*       No data to load. You are in offline mode with no local data store. Please reconnect to WIFI and try again.*/}
                    {/*    </div>*/}
                    {/*}*/}
                </Container>

            </div>
        </>
    )
}

export default DispatchPage